import { render, staticRenderFns } from "./DeliverTable.vue?vue&type=template&id=cbfd8222"
import script from "./DeliverTable.vue?vue&type=script&lang=js"
export * from "./DeliverTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbfd8222')) {
      api.createRecord('cbfd8222', component.options)
    } else {
      api.reload('cbfd8222', component.options)
    }
    module.hot.accept("./DeliverTable.vue?vue&type=template&id=cbfd8222", function () {
      api.rerender('cbfd8222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/internal/components/LogisticsTable/DeliverTable.vue"
export default component.exports